export const SINGLE_MINT_COST = 10500000;

export const SKEY_DECIMAL = 10 ** 8;
